


<div *ngFor="let consul of consultas">
    <app-chat
        [eventos] = 'eventos' 
        [consulta] = 'consul'>
    </app-chat>
    <br>
</div>